import React from 'react';

export default React.createContext({
    authSuccess : false,
    setAuthSuccess: (value) => {}
});


// WEBPACK FOOTER //
// ./src/components/ConnexionContext/ConnexionContext.js